const formatPhone = (phone: string | null | undefined): string => {
    // Handle null or undefined
    if (!phone) return '';

    try {
        // Remove all non-numeric characters
        const digits = phone.replace(/\D/g, '');

        // US 10-digit format: (XXX) XXX-XXXX
        if (digits.length === 10) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
        }

        // US with country code: +1 (XXX) XXX-XXXX
        if (digits.length === 11 && digits.startsWith('1')) {
            return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
        }

        // Local 7-digit number: XXX-XXXX
        if (digits.length === 7) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 7)}`;
        }

        // Extensions or special cases
        if (digits.length > 10 && digits.startsWith('1')) {
            // Handle US number with extension
            const mainNumber = digits.slice(0, 11);
            const extension = digits.slice(11);

            return `+1 (${mainNumber.slice(1, 4)}) ${mainNumber.slice(4, 7)}-${mainNumber.slice(7, 11)} ext. ${extension}`;
        }

        // If we can't determine the format, return the original
        return phone;
    } catch (error) {
        // If any error occurs during formatting, return the original
        console.warn("Phone formatting error:", error);
        return phone;
    }
};

export { formatPhone };